import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        minWidth: 0
    }
});

export const useStyles = ({
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
}) => {
    return {
        container: {
            gap: spaces.spacingXs
        }
    };
};
export default stylesheet;
